export class ErrorInDialog {
  constructor(public readonly errorInstance: Error, public readonly retryFn?: () => Promise<void> | void) {}
}
